import { render } from "./SelfAssessmentV2CloseConfirm.vue?vue&type=template&id=4e49f64c&scoped=true"
import script from "./SelfAssessmentV2CloseConfirm.vue?vue&type=script&lang=js"
export * from "./SelfAssessmentV2CloseConfirm.vue?vue&type=script&lang=js"

import "./SelfAssessmentV2CloseConfirm.vue?vue&type=style&index=0&id=4e49f64c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e49f64c"]])

export default __exports__